<template>
  <section class="bg-black">
    <div class="parallax-about relative" data-aos="fade"></div>
    <div class="parallax-text"></div>
    <div class="page-container">
      <div class="about-heading">
        <p class="JC text-5xl sm:text-xl" data-aos="fade-right">JAPANESE CUISINE</p>
        <div id="red-text" class="w-1/3" data-aos="fade-left">
          <div class="IRASHAI text-2xl xl:text-lg lg:text-lg sm:text-lg" data-aos="fade-left">
            I R A S S H A I M A S E !
          </div>
          <div class="p11 text-sm" data-aos="fade-left">
            With 18 years of knowledge and experience in Japanese cuisine, we
            learn to respect the tradition and stay true to the art of Japanese
            cuisine. However, we believe there’s no limit in perfecting a craft,
            innovation and creativity will elevate our understanding about food.
          </div>
        </div>
      </div>
      
    </div>
    <div class="bg-black pb-44 w-4/5 sm:w-full m-auto sm:h-screen" id="about-mid-img">
        <img
          :src="require('../assets/About/about-mid-img.jpg')"
          alt=""
          data-aos="fade-up"
        />
      </div>
  </section>
</template>

<script>
export default {};
</script>

<style>
.page-container {
  max-width: 80%;
  overflow: hidden;
  margin: auto;
}
[data-aos^=zoom].aos-animate
{
  opacity: 1;
  transform: translateZ(0) scale(1);
}
[data-aos^=zoom]
{
  opacity: 0;
    transition-property: opacity,transform;
}
[data-aos=zoom-in] 
{
  transform: scale(.2);
}

[data-aos^="fade"].aos-animate {
  opacity: 1;
  transform: none;
}
[data-aos^="fade"] {
  opacity: 0;
  transition-property: opacity, transform;
}
[data-aos="fade-right"] {
  transform: translate3d(-100px, 0, 0);
}
[data-aos="fade-left"] {
  transform: translate3d(100px, 0, 0);
}
[data-aos="fade-up"] {
  transform: translate3d(0, 100px, 0);
}

#about-mid-img img {
  margin: auto;
  width: 100%;
}
.ppp {
  margin: auto;
}
.p11 {
  font-family: avenirLight;
  font-style: normal;
  font-weight: 300;

  /* or 150% */
  padding-top: 5%;
  text-align: left;
  letter-spacing: 0.02em;

  /* white */

  color: #ffffff;
}
#red-text {
  position: relative;
  
  height: auto;
  float: right;
}
.IRASHAI {
  position: relative;
  height: auto;
  width: 100%;
  font-family: Times;
  font-style: normal;
  font-weight: normal;

  /* or 100% */

  letter-spacing: 0.2em;
  text-transform: uppercase;

  color: #c7272b;
}

.parallax-about {
  /* The image used */
  background-image: url("~@/assets/About/About-image.jpg");

  /* Set a specific height */
  min-height: 120vh;

  /* Create the parallax scrolling effect */
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  margin-top: -200px;
}
@media only screen and (max-width:639px)
{
.parallax-about {
background-attachment: unset;
  background-size: auto;
}
}
.parallax-text {
  height: 200px;
  background-image: url("~@/assets/images/Vector.png");
  margin-top: -70px;
  z-index: 999;
  position: relative;
}
.about-heading {
  height: 70vh;
  background: black;
  font-size: 2.25rem;
line-height: 2.5rem;
  padding: 5% 0 10% 0;
}

.JC {
  position: relative;
  width: 18%;
  height: 100px;
  font-family: Times;
  font-style: normal;
  font-weight: normal;


  /* or 109% */

  text-align: left;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  /* white */

  color: #ffffff;
}
@media only screen and (max-width:639px)
{
  #about-mid-img img {
 height: 60vh;
    object-fit: cover;
}
  .JC
  {
    width:60%;
  }
  #red-text
  {
    width:100%;
  }
  .about-heading {
  height: 50vh;}
}
</style>